/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCLeftIcon20Solid = forwardRef('ArrowCLeftIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M13.597 17.222a1.375 1.375 0 0 1-1.944 0L6.64 12.21a3.125 3.125 0 0 1 0-4.42l5.013-5.013a1.375 1.375 0 1 1 1.944 1.945L8.584 9.735a.375.375 0 0 0 0 .53l5.013 5.013a1.375 1.375 0 0 1 0 1.944Z" })));
});
